// removed by extract-text-webpack-plugin
module.exports = {"dialogCard":"DialogCard__dialogCard","title":"DialogCard__title","message":"DialogCard__message","childrenContainer":"DialogCard__childrenContainer","growDotQello":"DialogCard__growDotQello","growDotBlue":"DialogCard__growDotBlue","growDotGolden":"DialogCard__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DialogCard/DialogCard.scss
// module id = 1848
// module chunks = 0